import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { useState } from "react";
import Layout from "./components/Layout";
import { lightTheme, darkTheme } from "./theme";
import Home from "./pages/Home";
import Dashboard from "./components/dashboard/Dashboard";
import Timer from "./pages/Timer";
import Stopwatch from "./pages/Stopwatch";
import Blog from "./pages/Blog";
import Sponsorship from "./pages/Sponsorship";
import Pomodoro from "./pages/Pomodoro";
import PiChallenge from "./pages/PiChallenge";
import Login from "./components/auth/Login";
import Signup from "./components/auth/Signup";
import AuthCallback from "./components/auth/AuthCallback";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import "./App.css";

//Added Comments
export default function App() {
  const [darkMode, setDarkMode] = useState(false);

  return (
    <AuthProvider>
      <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
        <CssBaseline />
        <BrowserRouter>
          <Routes>
            <Route path="/auth/callback" element={<AuthCallback />} />

            <Route
              path="/"
              element={<Layout darkMode={darkMode} setDarkMode={setDarkMode} />}
            >
              <Route index element={<Home />} />
              <Route path="timer" element={<Timer />} />
              <Route path="pomodoro" element={<Pomodoro />} />
              <Route path="stopwatch" element={<Stopwatch />} />
              <Route path="blog/*" element={<Blog />} />
              <Route path="sponsorship" element={<Sponsorship />} />
              <Route path="pi-challenge" element={<PiChallenge />} />
              <Route path="login" element={<Login />} />
              <Route path="signup" element={<Signup />} />
              <Route
                path="dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </AuthProvider>
  );
}
